export default __webpack_public_path__ + "static/media/icons-delete-18-px.c62f258b.svg";